<template>
    <div id="app">
        <router-view name="header"></router-view>
        <router-view name="rebate"></router-view>
        <main>
            <router-view></router-view>
        </main>
        <router-view name="footer"></router-view>
    </div>
</template>

<script>
export default {
    name: 'App'
};
</script>

<style lang="scss" src="./main.scss"></style>
